import React, { Component } from 'react';
import Loading from '../../Loading';

import Zooming from 'zooming'
import VideoResolucao from '../../VideoResolucao';

const zooming = new Zooming({
    customSize: '200%',
    transitionDuration: 0.1,
    bgOpacity: 0.9,
    onClose: () => {
        var divId = 'image-zoom';
        let imageZoom = document.getElementById(divId)
        if(!imageZoom){
            console.error("Zooming PLugin error: There is no div element with id="+divId);
            return;
        }
        while (imageZoom.firstChild) {
            imageZoom.removeChild(imageZoom.firstChild);
        }
    }
})

class Questao extends Component {

    questionUpdated = false

    componentDidMount() {
        this.initZoomImg()
    }

    componentWillUnmount() {
        this.resetZoomImg()
    }

    initZoomImg() {
        const enunciado = document.getElementById('enunciado-questao')
        if (enunciado) {
            const imgs = enunciado.getElementsByTagName('img')
            for (let i = 0; i < imgs.length; i++) {
                let img = imgs[i]
                const imgSrc = img.getAttribute('src')
                img.addEventListener('click', this.onClickImg)
                img.style.cursor = 'zoom-in'
                img.src = imgSrc
            }
            return true
        }
        return false
    }

    resetZoomImg() {
        const enunciado = document.getElementById('enunciado-questao')
        if (enunciado) {
            const imgs = enunciado.getElementsByTagName('img')
            for (let i = 0; i < imgs.length; i++) {
                let img = imgs[i]
                img.removeEventListener('click', this.onClickImg)
            }
        }
    }

    onClickImg(event) {
        let imageZoom = document.getElementById('image-zoom')
        let img = document.createElement('img')
        img.src = event.target.src
        imageZoom.appendChild(img)
        zooming.open(img)
    }

    getQuestao() {
        return this.props.questao || {};
    }

    getOpcaoSelecionada() {
        return (this.props.opcaoSelecionada || "");
    }

    getOpcoesQuestao() {
        return this.getQuestao().opcoes || []
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.numeroQuestao !== this.props.numeroQuestao) {
            this.questionUpdated = true
            this.resetZoomImg()
        }
    }

    componentDidUpdate() {
        if (this.questionUpdated) this.questionUpdated = !this.initZoomImg()
    }
    render() {
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)

        return (<div className={" adap-white edb-round-large " + this.props.className}>

            {this.props.loading && <div className="edb-padding-large"> <Loading /> </div>}

            {!this.props.loading && this.props.questao &&
                <div>
                    <div className="edb-padding-large  adap-simulado-questao">

                        {/* ******** Video Resolução ********** */}
                        {this.props.questao.urlVideo && <VideoResolucao video={this.props.questao.urlVideo} events={this.props.videoResolucaoEvents} />}

                        {/* ******** Enunciado ********** */}
                        {this.props.numeroQuestao && <div className="edb-text-bold">Questão {this.props.numeroQuestao}</div>}
                        <div id="enunciado-questao" className="edb-margin-top" dangerouslySetInnerHTML={{ __html: this.getQuestao().enunciado }}></div>
                        {this.getQuestao().imagem && <div className="edb-center edb-padding">
                            <img className="edb-image" style={{ cursor: 'zoom-in' }} src={this.getQuestao().imagem} alt={this.getQuestao().imagem.descricaoImagem} onClick={this.onClickImg} />
                        </div>}

                        <div>{this.getQuestao().complemento}</div>

                        {/***************** Opçãoes ******************/}
                        <div className="edb-margin-top edb-inline">
                            {this.getOpcoesQuestao().map((item, index) => {
                                const props = {};

                                let labelClass = '';
                                // read only
                                if(this.props.somenteLeitura) {
                                    props.disabled = true;
                                    if(this.props.questao.respostaCorreta) {
                                        if(this.props.questao.respostaCorreta.toString() === item.id.toString()) {
                                            labelClass = ' adap-opcao-correta'
                                        }
                                        else if (this.props.questao.resposta && this.props.questao.resposta.toString() === item.id.toString()){
                                            labelClass = ' adap-opcao-incorreta';
                                        }
                                    }
                                }
                                else {
                                    labelClass = 'edb-pointer';
                                    // onchange
                                    if(this.props.onChangeOpcao) {
                                        // console.log('onChange')
                                        props.onChange = () => this.props.onChangeOpcao(item.id);
                                    }
                                }

                                // default checked
                                props.checked = false;
                                // console.log(this.getOpcaoSelecionada().toString(),index, item.id.toString())
                                if(this.getOpcaoSelecionada().toString() === item.id.toString()) {
                                    props.checked = true;
                                    // console.log('props.checked')
                                }

                                // console.log(this.props.questao.id, labelClass, index);

                                return <div className="edb-padding-small" key={`opcao${index}`}>
                                    <label className={labelClass}>
                                        <input type="radio" value={item.id}
                                            name={`opcoes-questao${this.props.numeroQuestao}`}
                                            {...props} />
                                        <span className="edb-margin-small-left" dangerouslySetInnerHTML={{ __html: item.descricao }}></span>
                                    </label>
                                </div>
                            }
                            )}
                        </div>
                    </div>
                    {!this.props.somenteLeitura && <div className="edb-row edb-margin-top edb-padding-small-2 edb-padding-none-mobile edb-padding">
                        <div className="edb-col s6 edb-padding-small-right">

                            {!this.props.esconderBtnDuvida && <button className={(!touchsupport?"edb-button":"adap-button-mobile")+" adap-light-yellow edb-round  edb-block-mobile edb-padding-small-mobile"}
                                onClick={() => this.props.onClickDuvida && this.props.onClickDuvida(this.getOpcaoSelecionada())} >
                                <i className="edb-margin-small-right adap-text-red fas fa-question-circle"></i>
                                <span className="edb-hide-small edb-hide-medium">Estou em dúvida, marcar para voltar depois</span>
                                <span className="edb-hide-large edb-small">Marcar como dúvida</span>
                            </button>}
                            &nbsp;

                        </div>
                        <div className="edb-col s6 edb-right-align ">
                            {!this.props.esconderBtnConfirmar &&<button className="edb-button adap-green edb-round edb-block-mobile"
                                onClick={() => this.props.onClickConfirmar && this.props.onClickConfirmar(this.getOpcaoSelecionada())}
                                disabled={!this.getOpcaoSelecionada()} >
                                &nbsp;&nbsp;Confirmar&nbsp;&nbsp;
                            </button>}
                        </div>
                    </div>}
                </div>}
        </div>);
    }
}

export default Questao;